import { Modal, Button, Alert } from "react-bootstrap";

const DeleteModal = ({
  show,
  onHide,
  onConfirm,
  text = "Ali ste prepričani, da želite izbrisati",
  naziv,
  isError = false,
  errorMessage = "Napaka pri brisanju. Prosimo, poskusite znova.",
  isPending = false,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body>
        {isError && (
          <Alert variant="danger" className="mb-3">
            {errorMessage}
          </Alert>
        )}
        {text} <strong>{naziv}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isPending}>
          Prekliči
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isPending}>
          {isPending ? "Brisanje..." : "Izbriši"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
